import { LicensePlateStep, ProductStep,AvailabilityStep, CustomerStep, CompletedStep } from '@/Components/steps'
import FormikSteps from '@/Components/formik-steps'
import './index.css'

const DEV_START_INDEX = 0

function App() {
  return (
    <div className="max-w-[590px] mx-auto w-full p-2 mt-[55px] mb-[100px]">
      <FormikSteps
        onSuccess={(values, extra) => { }}
        env={{
          index: DEV_START_INDEX,
          endpoint: '/wp-json/all-mobile-cars/v1/contact'
        }}
        initialValues={{
          mileage: null,
          license_found: false,
          manual_fill: false,
          license: '',
          brand: '',
          build: '',
          active_activities: [],
          availability: null,
          activities: [],
          availabilities: [],
          show_availabilities: false,
          first_name: '',
          last_name: '',
          naw: '',
          postal_code: '',
          house_number: '',
          house_number_addition: '',
          address: '',
          email: '',
          terms_agreement: false,
          data_agreement: false,
          phone: '',
          errors: []
        }}
        initialSteps={[
          LicensePlateStep,
          ProductStep,
          AvailabilityStep,
          CustomerStep,
          CompletedStep
        ]}
      />
    </div>
  )
}

export default App;
